"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const PanelLayout_1 = require("../MenuPanel/PanelLayout");
const EVENT_SELECT = {
    title: true,
    description: true,
    images: true,
    slug: true,
    place: true,
    date: true,
    startTime: true,
    endTime: true,
};
const PanelLayoutImg = (0, app_1.styled)(PanelLayout_1.PanelLayout) `
  position: relative;
  &:after {
    position: absolute;
    content: '';
    inset: 0;
    background-image: url('${(_, { $url }) => $url}');
    background-position: center;
    background-size: cover;
    display: none;
  }
  &:hover:after {
    display: block;
    opacity: 0.25;
  }
`;
const EventStack = (0, app_1.styled)(ui_1.Stack) `
  flex: 1;
`;
function EventView({ event, loading, }) {
    const { t } = (0, app_1.useTranslation)();
    const eventPath = (0, app_1.useContextPath)('event');
    if (loading) {
        return ((0, jsx_runtime_1.jsx)(PanelLayout_1.PanelLayout, { children: (0, jsx_runtime_1.jsx)(ui_1.Loading, {}) }));
    }
    if (!event) {
        return ((0, jsx_runtime_1.jsx)(PanelLayout_1.PanelLayout, { children: (0, jsx_runtime_1.jsx)(app_1.Text, { children: t('event.noEvents') }) }));
    }
    const [img] = event.images;
    const imgUrl = `${eventPath}/${event.id}/${img.name}`;
    return ((0, jsx_runtime_1.jsxs)(PanelLayoutImg, Object.assign({ "$url": imgUrl }, { children: [(0, jsx_runtime_1.jsxs)(EventStack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h2", as: "sub-h1" }, { children: event === null || event === void 0 ? void 0 : event.title })), (0, jsx_runtime_1.jsx)(app_1.Text, { children: (0, app_1.plainRichText)(event === null || event === void 0 ? void 0 : event.description) })] })), (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsxs)(app_1.Text, { children: [event.date.toLocaleDateString(), event.startTime
                                ? ` | ${event.startTime}${event.endTime ? ` - ${event.endTime}` : ''}`
                                : ''] }), event.place ? (0, jsx_runtime_1.jsx)(app_1.Text, { children: event.place }) : null] }))] })));
}
function EventWithQuery({ onlyFuture = false, }) {
    const { data: event, loading } = (0, app_1.useQuery)('getEventNearest', {
        args: { onlyFuture },
        select: EVENT_SELECT,
    });
    return (0, jsx_runtime_1.jsx)(EventView, { event: event, loading: loading });
}
function Event(_a) {
    var { query } = _a, props = __rest(_a, ["query"]);
    return query ? (0, jsx_runtime_1.jsx)(EventWithQuery, Object.assign({}, query)) : (0, jsx_runtime_1.jsx)(EventView, Object.assign({}, props));
}
exports.Event = Event;
Event.SELECT = EVENT_SELECT;
